import { ApiOperationBase } from 'api/rtk-api'
import { Currency } from 'utilities/currency'

import { Amount, MetaInformation, Submitted } from './event-information'

export interface DepositWithdrawalProps {
  currency: Currency
  date: string
  operation: ApiOperationBase
}

export const DepositWithdrawal = ({ currency, date, operation }: DepositWithdrawalProps) => (
  <MetaInformation>
    {operation.associatedInstruction && (
      <Amount
        currency={currency}
        value={
          (operation.associatedInstruction as any).requestedValue ||
          (operation as any).completedValue
        }
      />
    )}
    <Submitted date={date} />
  </MetaInformation>
)
